import DisclosureEx from "@components/DisclosureEx";
import React from "react";
import RadioInput from "@components/RadioInput";
import {useForm} from "react-hook-form";
import {PresenzeOptions, SitePreferences, TokenRecord} from "@commons/mapping/TokenRecord";
import CheckboxEx from "@components/wrapperComponents/CheckboxEx";
import {useAppDispatch, useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectToken} from "@commons/core.slice";
import {IconTool} from "@tabler/icons-react";

interface OpzioniPresenzeProps {
    sitePreferences: SitePreferences,
}

const OpzioniPresenze: React.FC<OpzioniPresenzeProps> = ({sitePreferences}) => {

    const dispatch = useAppDispatch();
    const token: TokenRecord | null = useAppSelector(selectToken);

    const defaultValues: PresenzeOptions = sitePreferences.presenzeOptions;
    const form = useForm<PresenzeOptions>({defaultValues});
    const {getValues, control, register,} = form;

    /* TODO aggiornamento SITE PREFERENCES!!!
        function updSitePreferences(filter: PresenzeOptions) {
            dispatch(updateSitePreferences({token: token!.token, pref: {...sitePreferences, presenzeOptions: filter}})).then((r) => {
                /!*if (r.type === changeDomain.rejected.type)
                    toast("ERRORE in aggiornamento Site Preferences!", {type: 'error'})*!/
            });
        }
        function changeOptions() {
            console.log('changeOptions()')
            const presenzeOptionsUpdated: PresenzeOptions = getValues();
            updSitePreferences(presenzeOptionsUpdated)
        }
    */

    return (
        <DisclosureEx accordionColor="bg-[#235f6a] hover:bg-[#1b4952] text-white"
                      accordionTitle="Opzioni" icon={<IconTool className="w-4 h-4"/>} accordionState={false}>
            <div className="inline-flex w-full">
                <div className="basis-1/3">
                    <label htmlFor="tipoVista" className="mb-1 block font-medium text-sm">Tipo vista</label>
                    <RadioInput
                        label="Calendario" name="dayView" id="calendario" value="calcendario"
                        register={register} registerOptions={{required: true}}/>
                    <RadioInput
                        label="Lista" name="dayView" id="lista" value="lista"
                        register={register} registerOptions={{required: true}}
                    />
                </div>
                <div className="basis-1/3">
                    <label className="mb-1 block font-medium">Altro</label>
                    <CheckboxEx name="mostraDescrizioneTurno"
                                control={control}
                                label="Mostra descrizione distribuzione oraria"/>
                    <CheckboxEx name="showWeekTotal"
                                control={control}
                                label="Mostra totali settimanali"/>
                    <CheckboxEx name="mostra5Coppia"
                                control={control}
                                label="Mostra 5&#94; coppia"/>
                    <CheckboxEx name="mostraGiuQI"
                                control={control}
                                label="Mostra giustificativi a importo e quantit&agrave;"/>
                    <CheckboxEx name="noFocusFn"
                                control={control}
                                label="Non selezionare il button corrispondente al tasto funzione quando premuto"/>
                </div>
            </div>
        </DisclosureEx>
    )
}
export default OpzioniPresenze;